module.exports = __webpack_public_path__ + "static/media/grafite.0e39af28.jpg";